import React from "react";
import { useNavigate } from "react-router-dom";

const Sample = () => {
  const navigate = useNavigate();
  const onLoginClick = () => {
    navigate("/login");
  };

  const onPush = (event) => {
    console.log(event.data);
    // From here we can write the data to IndexedDB, send it to any open
    // windows, display a notification, etc.
  };

//   navigator.serviceWorker.register("serviceworker.js");

//   // Use serviceWorker.ready to ensure that you can subscribe for push
//   navigator.serviceWorker.ready.then((serviceWorkerRegistration) => {
//     const options = {
//       userVisibleOnly: true,
//       applicationServerKey,
//     };
//     serviceWorkerRegistration.pushManager.subscribe(options).then(
//       (pushSubscription) => {
//         console.log(pushSubscription.endpoint);
//         // The push subscription details needed by the application
//         // server are now available, and can be sent to it using,
//         // for example, an XMLHttpRequest.
//       },
//       (error) => {
//         // During development it often helps to log errors to the
//         // console. In a production environment it might make sense to
//         // also report information about errors back to the
//         // application server.
//         console.error(error);
//       }
//     );
//   });

  return (
    <main>
      <h1 className="text-3xl font-bold underline" onClick={onPush}>
        Akbar Sha world!
      </h1>
      <h1 className="text-2xl font-bold">Login to your account</h1>
      <input type={"text"} placeholder="Text" className="inputTag" />
      <input type={"number"} placeholder="Number" className="bg-gray-400" />
      <button onClick={onLoginClick}>Go to login page</button>
    </main>
  );
};

export default Sample;
